import { Fragment, h } from "preact"
import { AppPage } from "../../_common/components/app-page"
import { t } from '../../_i18n'
import { connect, useSelector } from "react-redux"
import {
    fetchExpedientAcademicProgram,
    fetchExpedientAcademicProgramsSelector,
    setReviewParams
} from "../../_rx/expediente/actions"
import { CF, E, FR, RE } from "../../_common/layout"
import { useEffect, useState } from "preact/hooks"
import AcademicProgramSelector from "../components/academicProgramSelector"
import NoticeModule from "../../_common/components/noticeModule/noticeModule"
import ModuleModal from "./moduleModal"
import { ShowTerms } from "../components/moduleModalDetail/gradeCalculation"
import ExpedienteMenu from "../components/expedienteHeader/expedienteMenu"
import Loading from "../../_common/components/loading/Loading"
import './expendiente.scss'
import ProgressSection from '../components/progressSection/ProgressSection'
import ProgressCard from '../components/progressSection/ProgressCard'
import { ButtonPrimary } from "../../_common/components/buttons/buttons";
import { DateTime } from "luxon"
import { STUDENT_NO_TITLE, STUDENT_NO_VALIDATED, STUDENT_VALIDATED } from "../../app/getUserRol"
import { ModalFinishedAPCertificate } from "../components/modalFinishedAPCertificate";
import { toastService } from "../../_services/toast-service"
import { isSpanishUser } from "../../_common/utils/getLang"
import { EDUCATION_LAW_LOIFP } from "../expedientConstants"
import ButtonSpinner from "../../_common/components/buttons/buttonSpinner/buttonSpinner"
import { downloadFile } from "../../utils"
import { ILERNA_FREE_AP_TYPE, ILERNA_PLUS_AP_TYPE, PS_SHOPID_ES, TOKEN_EXPEDIENT } from "../../constants"
import { STUDENT_TRIAL } from "../../app/getUserRol"
import Banner from "../../_common/components/Banner"

function ExpedienteView({ match, history, canvasId, expedient, studentId, educationLaw, isTrial, ...props }) {
    const [showAPCertificateButton, setShowAPCertificateButton] = useState(false)
    const [showIlernaFreeCertificateButton, setShowIlernaFreeCertificateButton] = useState(false)
    const [downloading, setDownloading] = useState(false)
    const [modalVisible, setModalVisible] = useState(false)
    const [modalAPFinishedVisible, setModalAPFinishedVisible] = useState(false)
    const [academicProgram, setAcademicProgram] = useState(null)
    const [academicProgramSelector, setAcademicProgramSelector] = useState([])
    const [academicProgramSelected, setAcademicProgramSelected] = useState(null)
    const [module, setModule] = useState(null)
    const { lang, student_access } = useSelector(state => state)
    const student_meta = useSelector(state => state.status.student_meta)
    const studentAccessForAcademicProgramCard = [STUDENT_NO_VALIDATED, STUDENT_VALIDATED, STUDENT_NO_TITLE]
    const [showGrades, setShowGrades] = useState(student_meta?.show_grades)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        const load = async () => {
            const programs = await props.fetchExpedientAcademicProgramsSelector(studentId)

            setAcademicProgramSelected(programs[0])
            setAcademicProgramSelector(programs)
            props.setReviewParams({})
        }

        load()
    }, [])

    useEffect(() => {
        if (academicProgram?.cis_academic_program_type_id !== ILERNA_FREE_AP_TYPE && academicProgram?.certificates?.length > 1) {
            setShowAPCertificateButton(true)
            setShowIlernaFreeCertificateButton(false)
        } else if (academicProgram?.allow_buy_grade_certificate_taxes) {
            const blocks = props.status?.blocks
            const studentAcademicProgramBlockKey = blocks ? Object.keys(blocks).find(key => blocks[key].block_name === 'student_academic_program') : false
            const studentAcademicProgramBlock = studentAcademicProgramBlockKey ? blocks[studentAcademicProgramBlockKey] : false
            const academicProgramCardAvailable = studentAcademicProgramBlock && studentAcademicProgramBlock?.status?.id > 0

            if (studentAccessForAcademicProgramCard.includes(student_access) && academicProgramCardAvailable) {
                setShowAPCertificateButton(true)
                setShowIlernaFreeCertificateButton(false)
            } else {
                setShowAPCertificateButton(false)
            }
        } else {
            setShowAPCertificateButton(false)
        }

        if ([ILERNA_FREE_AP_TYPE, ILERNA_PLUS_AP_TYPE].includes(academicProgram?.cis_academic_program_type_id) && academicProgram?.certificates?.length > 0) {
            setShowIlernaFreeCertificateButton(true)
            setShowAPCertificateButton(false)
        } else {
            setShowIlernaFreeCertificateButton(false)
        }
    }, [academicProgram])

    useEffect(async () => {
        if (academicProgramSelected) {
            fetchAcademicProgram()
        }
    }, [academicProgramSelected])


    useEffect(() => {
        const moduleIds = match.params.module_id

        if (!moduleIds && modalVisible) {
            setModalVisible(false)
            props.setReviewParams({})
        } else if (moduleIds && !modalVisible && module) {
            setModalVisible(true)
        } else if (!module && moduleIds) {
            history.push('/expediente')
        }
    }, [match.params.module_id])

    const handleProgramSelector = (programSelected) => {
        if (programSelected !== academicProgramSelected) {
            setAcademicProgramSelected(programSelected)
            setAcademicProgram(null)
        }
    }

    const handleModulePicked = (module) => {
        const hasChuldrenUrl = (module.has_children) ? 'ch' : 'sb'
        setModule(module)
        history.push('/expediente/' + hasChuldrenUrl + '-' + module.id)
    }

    const getRecognitionText = (module) => {
        if (!module.recognized_new || module.recognized_new.status === 0)
            return ''

        const timeLimitDate = DateTime.fromFormat(module.recognized_new.timelimit, 'yyyy-MM-dd hh:mm:ss')

        const statusKey = module.recognized_new.status === 2 ? 'recognition_denied' : 'recognition_requested'
        const statusKeyPrefix = module.recognized_new.type === 0 ? 'partial_' : ''
        const managementKey = timeLimitDate < DateTime.now() ? 'recognition_management_will_start' : 'recognition_management_started'

        const locale = lang === 'fr' && 'fr-FR' || lang === 'it' && 'it-IT' || 'es-ES'
        const dateString = timeLimitDate.setLocale(locale).toLocaleString({ month: 'long', year: 'numeric' })

        const managementString = module.recognized_new.status !== 2 ? t(managementKey).replace('{datelimit}', dateString) + '. ' : ''

        return `<span class='font-bold'>${t(statusKeyPrefix + statusKey) + (module.recognized_new.status !== 2 ? ':' : '')} </span>${managementString}<span class='t-underline'>${t('recognition_more_info')}</span>.`
    }

    const handleCertificateButton = () => {
        if (academicProgram?.certificates?.length > 1) {
            setModalAPFinishedVisible(true)
        } else if (isSpanishUser(student_meta.shop_id) && academicProgram?.formative_zone.includes('MAD') && academicProgram?.allow_buy_grade_certificate_taxes) {
            history.push('/secretaria/solicitud-titulo')
        } else if (academicProgram?.allow_buy_grade_certificate_taxes) {
            history.push('/academic-program-card')
        } else {
            // This should never be reached but just in case...
            toastService.showToast({ message: t('El certificado no esta disponible'), type: 'danger' })
        }
    }

    const handleDownloadIlernaFreeCertificate = () => {
        setDownloading(true)
        downloadFile({
            url: academicProgram.certificates[0].link,
            fileName: academicProgram.certificates[0].name,
            TOKEN: TOKEN_EXPEDIENT,
            method: 'GET'
        }).then(() => setDownloading(false))
    }

    const fetchAcademicProgram = async () => {
        setIsLoading(true)
        const academicProgram = await props.fetchExpedientAcademicProgram(studentId, academicProgramSelected.id)
        if (academicProgram.education_law_title === EDUCATION_LAW_LOIFP) {
            academicProgram.modules = academicProgram.modules?.filter(m => m.is_training_work_center === false)
        }
        setAcademicProgram(academicProgram)
        setShowGrades(academicProgram.show_grades)
        setIsLoading(false)
    };

    return <CF className="max-width">
        <div className='d-flex flex-space-between flex-center-y'>
            <h1 className='hero expedient-title'>{t('Expediente académico')}</h1>
            {academicProgram &&
                <ExpedienteMenu academicProgramId={academicProgram.id} academicProgram={academicProgram} showGrades={showGrades} />}
        </div>
        {isLoading ? (
            <CF className="max-width">
                <Loading label={`${t('Cargando')}. . . `} />
            </CF>
        ) : (
            <Fragment>
                {academicProgramSelector?.length > 1 && (
                    <RE className="mb-4">
                        <AcademicProgramSelector
                            academicProgramSelector={academicProgramSelector}
                            onChange={handleProgramSelector}
                        />
                    </RE>
                )}

                {showGrades ? (
                    <Fragment>

                        {!academicProgram ? (
                            <div className='m-top'>
                                <Loading label={`${t('Cargando')}. . . `} />
                            </div>
                        ) : (
                            <Fragment>

                                {(!isTrial && academicProgram?.schoolCenter) && (
                                    <div className="mb-4">
                                        <span>
                                            {t('Centro')}: <b className="font-bold">{academicProgram.schoolCenter?.onlineTitle ?? ''}</b> ({t('codigo')} {academicProgram.schoolCenter?.educationCenterCode ?? ''})
                                        </span>
                                    </div>
                                )}

                                {(!isTrial && academicProgram.approved) ? (
                                    <FR className='d-block sm-no-reverse'>
                                        <E>
                                            <div className='col-35 no-margin'>
                                                <ProgressCard
                                                    title={t('Nota final')}
                                                    grade={academicProgram.grade}
                                                    subtitle={t('Ciclo finalizado')}
                                                />
                                            </div>
                                        </E>

                                        {showAPCertificateButton && student_meta.shop_id === PS_SHOPID_ES && student_meta.formative_zone.toUpperCase() === 'CAT' &&
                                            <FR>
                                                {/* TODO: Get the certificate 0 when only 1 recovered from back */}
                                                {!academicProgram?.certificates[2]?.disabled &&
                                                    <E>
                                                        <ButtonPrimary
                                                            className='full-width sm-no-full-width ml-2'
                                                            onClick={handleCertificateButton}
                                                        >
                                                            {t('Solicitar certificado de ciclo finalizado')}
                                                        </ButtonPrimary>
                                                    </E>
                                                }
                                                <ModalFinishedAPCertificate academicProgram={academicProgram}
                                                    visible={modalAPFinishedVisible}
                                                    closeModal={() => setModalAPFinishedVisible(false)}
                                                    onFinished={fetchAcademicProgram}
                                                />
                                            </FR>
                                        }

                                        {showIlernaFreeCertificateButton && (
                                            <FR>
                                                <E>
                                                    <ButtonSpinner
                                                        className='full-width sm-no-full-width'
                                                        onClick={handleDownloadIlernaFreeCertificate}
                                                        showSpinner={downloading}
                                                        disabled={downloading}
                                                    >
                                                        {t('Descargar certificado de aprovechamiento')}
                                                    </ButtonSpinner>
                                                </E>
                                            </FR>
                                        )}

                                    </FR>
                                ) : (
                                    !isTrial && educationLaw !== EDUCATION_LAW_LOIFP &&
                                    <ProgressSection academicProgram={academicProgram} />
                                )}

                                <div className='m-bottom'>
                                    <div className='expedient-grades-header'>
                                        <div className='expedient-grades-header__title large font-14'>
                                            {t('Módulos profesionales')}
                                        </div>
                                        <div className='expedient-grades-header__grade large font-14'>
                                            {t('nota')}
                                        </div>
                                    </div>

                                    {academicProgram.modules?.map(module => {
                                        const teachingHours =
                                            (educationLaw !== EDUCATION_LAW_LOIFP && module.teaching_hours)
                                                ? `- ${module.teaching_hours} ${t('horas')}`
                                                : ''

                                        return (
                                            <NoticeModule
                                                key={module.id}
                                                subTitle={`${module.abbr} ${teachingHours}`}
                                                title={module.title}
                                                grade={module.grade}
                                                approved={module.approved}
                                                onClick={() => handleModulePicked(module)}
                                                isEnrolled={module.is_enrolled}
                                                enrolledStatus={module.enroll_status}
                                                textInfo={getRecognitionText(module)}
                                                hiddenGrade={module.hidden_grade}
                                                isProjectModule={module.is_project}
                                                isTrainingWorkCenterModule={module.is_training_work_center}
                                                large
                                                isEnabled
                                            />
                                        )
                                    })}
                                </div>

                                {educationLaw !== EDUCATION_LAW_LOIFP && (
                                    <div className='m-x2-top'>
                                        <ShowTerms
                                            educationLaw={educationLaw}
                                            formative_zone={academicProgram.formative_zone}
                                            main
                                        />
                                    </div>
                                )}

                                <ModuleModal
                                    parentId={academicProgram.id}
                                    visible={modalVisible}
                                    matchParams={match.params.module_id}
                                    params={match.params}
                                    module={module}
                                    onClick={() => history.push('/expediente')}
                                    historyRoute={history}
                                    formativeZone={academicProgram.formative_zone}
                                />

                            </Fragment>
                        )}

                    </Fragment>
                ) : (
                    <Banner color="warning" icon="warning" background="warning">
                        <span dangerouslySetInnerHTML={{ __html: t('expediente-no-docu') }} />
                    </Banner>
                )}

            </Fragment>
        )}
    </CF>
}

ExpedienteView = connect(
    ({ auth: { loggedUser }, status, expedient: { educationLaw }, student_access }) => (
        {
            status,
            educationLaw,
            studentId: loggedUser.id,
            isTrial: student_access === STUDENT_TRIAL,
        }
    ),
    { fetchExpedientAcademicProgramsSelector, fetchExpedientAcademicProgram, setReviewParams })(ExpedienteView)

let ExpedientePage = ({ match, ...props }) =>
    <AppPage
        name="expediente"
        class="max-width">
        <ExpedienteView match={match} {...props} />

    </AppPage>

export default ExpedientePage
